import {
  Component,
  Optional,
  Inject,
  Input,
  ViewChild,
  Injector,
} from '@angular/core';

import {
  NgModel,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  NG_ASYNC_VALIDATORS,
} from '@angular/forms';

import {ElementBase, animations} from '../form';

@Component({
  selector: 'form-slider',
  template: `
      <p-slider 
      [style]="{'width':'400px'}"
      [id]="identifier"
      pInputText 
      [min]="min" 
      [max]="max" 
      [animate]="animate"
      [step]="step"
      [range]="range"
      [orientation]="orientation"
      [disabled]="disabled"></p-slider>
      <label *ngIf="label" [attr.for]="identifier">{{label}}</label>
      
  `,
  animations,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: FormSliderComponent,
    multi: true,
  }]
})
export class FormSliderComponent extends ElementBase<string> {
  @Input() public placeholder: string = "";
  
  @Input() public disabled: boolean = false;
  // @Input() public readonly: boolean = false;
  @Input() public min: number;
  @Input() public max: number;
  @Input() public animate: boolean;
  @Input() public step: number;
  @Input() public range: boolean;
  @Input() public orientation: string;

  @ViewChild(NgModel) model: NgModel;

  public identifier = `form-slider-${identifier++}`;

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    injector: Injector
  ) {
    super(validators, asyncValidators, injector);
  }
}

let identifier = 0;



// WEBPACK FOOTER //
// ./src/app/base/base-fields/components/slider.ts